import ReactApexChart from "react-apexcharts";
import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../Utils/CommonComponents/CommonCardHeader/CommonCardHeader";
import { monthlyDropdownList, sellViewChart } from "../../../Data/Dashboard/Default";

const MonthlyOverview = () => {
  return (
    <Col xl="4" md="5" className="xl-50 box-col-6">
      <Card className="sellview-sec">
        <CommonCardHeader headClass="pb-0 card-no-border" mainTitle dropDownList={monthlyDropdownList} title={"Monthly Overview"} />
        <CardBody className="py-0">
          <ReactApexChart
            options={sellViewChart}
            series={sellViewChart.series}
            type="bar"
            height={330}
          />
        </CardBody>
      </Card>
    </Col>
  );
};

export default MonthlyOverview;
